<template>
  <div class="modal" v-if="isShow">
    <div class="con">
      <img
        v-if="type === 'send'"
        src="../../../assets/books/send-success.png"
        alt=""
      />
      <img
        v-else-if="type === 'copy'"
        src="../../../assets/books/copy-success.png"
        alt=""
      />
      <h3 v-if="type != 'qr'">{{ successText[type] }}</h3>
      <div v-if="type === 'send'" class="tips">
        <p>
          <span>资源已发送至</span><span class="black">{{ mail }}</span>
        </p>
        <p>请打开对应邮箱下载查看</p>
      </div>
      <div v-else-if="type === 'copy'" class="tips">
        <p>已复制资源下载链接,</p>
        <p>请粘贴到浏览器地址栏下载</p>
      </div>
      <button v-if="type != 'qr'" @click="trigger">我知道了</button>

      <!-- 二维码 -->
      <div class="qr" v-if="type === 'qr'">
        <span class="clear-icon" @click="trigger">X</span>
        <div class="tips">
          <p class="primary-color">长按二维码前往公众号登录</p>
        </div>
        <img :src="qrUrl" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // type: {
    //   type: String,
    //   default: 'copy',
    // },
    // mail: String,
  },
  data() {
    return {
      successText: {
        send: '发送成功',
        copy: '复制成功',
      },
      isShow: false,
      type: 'copy',
      mail: undefined,
      qrUrl: undefined,
    };
  },
  methods: {
    trigger(data = {}) {
      this.type = data.type;
      this.mail = data.mail;
      this.qrUrl = data.qrUrl;
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw !important;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
  .con {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 227px;
    padding: 15px 15px 15px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 6px;
    text-align: center;
  }
  img {
    width: 56px;
    margin-top: 47px;
    animation: down 0.1s linear;
  }
  h3 {
    color: #3b3e42;
    font-size: 16px;
    font-weight: 500;
    margin: 12px 0;
  }
  .qr {
    padding-top: 10px;
    img {
      margin: 0;
      width: 100%;
    }
  }
}
.tips {
  color: #999;
  font-size: 12px;
  .black {
    color: #3b3e42;
  }
  p + p {
    margin-top: 6px;
  }
}
button {
  display: inline-block;
  width: 197px;
  height: 38px;
  color: #fff;
  font-size: 14px;
  background: #0a93fc;
  border: 0;
  border-radius: 6px;
  margin: 0;
  margin-top: 34px;
  padding: 0;
  outline: none; //消除默认点击蓝色边框效果
}
@keyframes down {
  0% {
    transform: translateY(-1%);
  }
  100% {
    transform: translateY(0);
  }
}
.primary-color {
  color: #0a93fc;
}
.clear-icon {
  position: absolute;
  right: 4px;
  top: 0;
  font-size: 12px;
  color: #999;
  padding: 10px;
}
</style>
